import { useTranslation } from 'react-i18next';

import type { Product } from '~/api/products/types';

import { useDeleteProduct } from '~/api/products';
import { AlertDialog, Button } from '~/components';
import { toast } from '~/utils/toast';

type Props = {
  onClose: () => void;
  product: Product;
};

export const ConfirmDeleteProductDialog = ({ onClose, product }: Props) => {
  const { t } = useTranslation(['common', 'products']);

  const mutation = useDeleteProduct(product.id);

  const handleDeleteProduct = () => {
    mutation.mutate(undefined, {
      onSuccess: () => {
        toast.success({ description: t('products:alerts.successDeleted') });
        onClose();
      },
      onError: () => toast.danger({ description: t('common:error') }),
    });
  };

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('products:overview.deleteModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('products:overview.deleteModal.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Trash" loading={mutation.isPending} onClick={handleDeleteProduct}>
          {t('common:actions.delete')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
